module.exports = require('lodash').escapeRegExp